import { take, race, call } from 'redux-saga/effects';

import types from '@constants/action-types';

import { pollProcessingAggregatesSaga } from '../pollProcessingAggregatesSaga';

export const watchPollProcessingAggregatesSaga = function* () {
  while (true) {
    const payload = yield take(types.FETCH_PROCESSING_AGGREGATES_START);
    yield race([
      call(pollProcessingAggregatesSaga, payload),
      take(types.FETCH_PROCESSING_AGGREGATES_STOP),
    ]);
  }
};
